var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnUpArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-White_Arrow_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_Arrow_2",
    "data-name": "White Arrow \\u2013 2",
    clipPath: "url(#clip-White_Arrow_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34331",
    "data-name": "Path 34331",
    d: "M10.445,7.252v6.529h1.63V7.252h2.445L11.26,4,8,7.252Z",
    transform: "translate(-5 -2.891)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnUpArrowWhite);
export default __webpack_public_path__ + "static/media/ColumnUpArrowWhite.1b4e0b193be025649b89ee09090bb1a2.svg";
export { ForwardRef as ReactComponent };